// Page de test UX pour le dashboard configurable (CC-25b L1+L2+L3).
// Accès : /hub/dashboard-test  (Finance par défaut)
//         /hub/dashboard-test/{commercial|operation|conformite|finance|...}
// À retirer ou intégrer en hub propre après validation UX par JJ.
import { useParams, Link } from "react-router-dom";
import DashboardGrid from "../components/dashboard/DashboardGrid";
import { Button } from "../components/ui/button";
import { ArrowLeft } from "lucide-react";

const ALLOWED_HUBS = [
  "finance", "commercial", "operation", "conformite",
  "communication", "dashboard", "governance",
];

export default function DashboardTestPage() {
  const { hubName } = useParams();
  const hub = ALLOWED_HUBS.includes(hubName) ? hubName : "finance";

  return (
    <div className="min-h-screen" style={{ background: "var(--oh-bg)" }}>
      <header
        className="px-4 md:px-6 py-3 flex items-center gap-3"
        style={{
          background: "var(--oh-bg-elevated)",
          borderBottom: "1px solid var(--oh-border)",
        }}
      >
        <Link to="/hub" aria-label="Retour à l'OmniHub">
          <Button variant="ghost" size="sm" className="gap-1">
            <ArrowLeft className="w-4 h-4" />
            OmniHub
          </Button>
        </Link>
        <div className="min-w-0">
          <h1 className="text-base font-semibold" style={{ color: "var(--oh-text)" }}>
            Dashboard configurable — page de test
          </h1>
          <p className="text-xs" style={{ color: "var(--oh-text-muted)" }}>
            CC-25b L1+L2+L3 · Hub : <code>{hub}</code>
          </p>
        </div>
        <nav className="ml-auto flex items-center gap-1 overflow-x-auto">
          {ALLOWED_HUBS.map((h) => (
            <Link key={h} to={`/hub/dashboard-test/${h}`}>
              <Button
                size="sm"
                variant={h === hub ? "default" : "ghost"}
                className="text-xs"
              >
                {h}
              </Button>
            </Link>
          ))}
        </nav>
      </header>
      <main className="p-4 md:p-6">
        <DashboardGrid hub={hub} />
      </main>
    </div>
  );
}
